'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactAddonsCssTransitionGroup = require('react-addons-css-transition-group');

var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Summary = require('../container/summary/Summary');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Summary = function (_React$Component) {
  _inherits(Summary, _React$Component);

  function Summary(props) {
    _classCallCheck(this, Summary);

    return _possibleConstructorReturn(this, (Summary.__proto__ || Object.getPrototypeOf(Summary)).call(this, props));
  }

  _createClass(Summary, [{
    key: 'isAnyFinished',
    value: function isAnyFinished() {
      return this.props.finishedSteps.length > 0;
    }
  }, {
    key: 'isFinished',
    value: function isFinished(step) {
      var b = this.props.finishedSteps.indexOf(step) !== -1;
      return b;
    }
  }, {
    key: 'renderSummaryElements',
    value: function renderSummaryElements() {
      var summaryElements = [];
      if (this.isFinished("garage")) summaryElements.push(_react2.default.createElement(_Summary.GarageSummaryContainer, {
        key: 'g'
      }));
      if (this.isFinished("service")) summaryElements.push(_react2.default.createElement(_Summary.ServiceSummaryContainer, {
        key: 's'
      }));
      if (this.isFinished("mobility")) summaryElements.push(_react2.default.createElement(_Summary.MobilitySummaryContainer, {
        key: 'm'
      }));
      if (this.isFinished("timeslot")) summaryElements.push(_react2.default.createElement(_Summary.TimeslotSummaryContainer, {
        key: 't'
      }));
      if (this.isFinished("vehicle")) summaryElements.push(_react2.default.createElement(_Summary.VehicleSummaryContainer, {
        key: 'v'
      }));
      if (this.isFinished("simple-vehicle")) summaryElements.push(_react2.default.createElement(_Summary.SimpleVehicleSummaryContainer, {
        key: 'v2'
      }));
      if (this.isFinished("customer")) summaryElements.push(_react2.default.createElement(_Summary.CustomerSummaryContainer, {
        key: 'c1'
      }));
      if (this.isFinished("customer")) summaryElements.push(_react2.default.createElement(_Summary.MessageSummaryContainer, {
        key: 'c2'
      }));
      return summaryElements;
    }
  }, {
    key: 'render',
    value: function render() {
      var classes = (0, _classnames2.default)({
        summary: true,
        status: true,
        gray: this.props.enabled,
        disabled: !this.props.enabled
      });
      return _react2.default.createElement('div', {
        id: 'status',
        className: classes
      }, _react2.default.createElement(_reactAddonsCssTransitionGroup2.default, {
        transitionName: 'example',
        transitionEnterTimeout: 500,
        transitionLeaveTimeout: 300
      }, _react2.default.createElement('div', {
        key: 'statssub',
        className: 'sub'
      }, 'Ihre Auswahl'), this.renderSummaryElements()));
    }
  }]);

  return Summary;
}(_react2.default.Component);

Summary.propTypes = {
  finishedSteps: _propTypes2.default.array.isRequired,
  enabled: _propTypes2.default.bool
};
Summary.defaultProps = {
  enabled: true
};
exports.default = Summary;